import Lenis from 'lenis';

let lenis: Lenis | null = null;
let rafId = 0;

export const initLenisScroll = (): (() => void) => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return () => undefined;
  }

  if (lenis) {
    cancelAnimationFrame(rafId);
    lenis.destroy();
    lenis = null;
  }

  lenis = new Lenis();

  const raf = (time: number) => {
    lenis?.raf(time);
    rafId = requestAnimationFrame(raf);
  };

  rafId = requestAnimationFrame(raf);

  return () => {
    cancelAnimationFrame(rafId);
    lenis?.destroy();
    lenis = null;
  };
};

export const scrollToY = (top: number) => {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  if (lenis) {
    lenis.scrollTo(top, { immediate: reducedMotion });
    return;
  }

  window.scrollTo({
    top,
    behavior: reducedMotion ? 'auto' : 'smooth',
  });
};
